/**
 * @file science Hooks
 * @author v_duzhengqiang
 */

import { useState } from 'react';
import { useMount } from 'react-use';
import { getCmsDataInfo } from '../../api/pages/paddleCmsGetDataApi';
import {
    RootObject
} from './type';


const useEasyDeployHooks = () => {
    // // 数据
    const [data, setData] = useState<RootObject>(
        {
            easyDeployHeader: {
                easyDeployHeaderTitle: "",
                easyDeployHeaderContent: "",
                easyDeployHeaderJumpContent: [],
                description: ""
            },
            abilityToOverview: {
                abilityToOverviewTitle: "",
                content: [],
                description: ""
            },
            deploymentOfAbility: {
                deploymentOfAbilityTitle: "",
                subTitle: "",
                twoTitle: "",
                threeTitle: "",
                imgList: [],
                description: ""
            },
            applicationScenarios: {
                title: "",
                tabsList: [],
                description: ""
            },
            modelCovering: {
                title: "",
                data: [],
                description: "",
                imageClassificationTitle:"",
                targetDetectionTitle:"",
                ocrTitle:"",
                imageSegmentationTitle:"",
            },
            hardwareCoverage: {
                title: "",
                data: [],
                description: "",
                armCpu32bitTitle: "",
                armCpu64bitTitle: "",
                JetsonTitle: "",
                x86_cpuTitle: "",
                nvidia_GPUTitle: "",
            },
            easyDeployFotter: {
                easyDeployFotterTitle: "",
                easyDeployFotterContent: [],
                description: ""
            },
            qrCode: {
                qrCodeTitle:"",
                qrCodeDesc:"",
                backImg:"",
                stepsOne:"",
                stepsTwo:"",
                description:""
            }
        }
    );

    useMount(() => {
        (async () => {
            const res = await getCmsDataInfo({ requestUrl: '/easy_deploy' })
                .catch((err) => {
                    // ignore
                });
            if (res) {
                const data = res.body.result?.pageData || {};
                // console.log(data);

                data && setData(data);

            }
        })();
    });
    return {
        data

    }
}

export default useEasyDeployHooks;